export function resolveMealPrepEditorialState({
  stale = false,
  dirty = false,
  status = "draft",
  totalTasks = 0,
  lastLocalAction = null,
} = {}) {
  if (totalTasks === 0) {
    return {
      label: "Pas encore préparé",
      nextStep: "Crée une première proposition depuis les recettes validées.",
      refreshLabel: "Créer la proposition",
      refreshDisabled: false,
      tone: "neutral",
    };
  }

  if (stale) {
    return {
      label: "Recettes modifiées · actualisation requise",
      nextStep: "Actualise le Meal Prep avant de l’enregistrer.",
      refreshLabel: "Actualiser depuis les recettes",
      refreshDisabled: false,
      tone: "warning",
    };
  }

  if (dirty) {
    const refreshed = lastLocalAction === "refreshed";
    return {
      label: refreshed
        ? "Recettes actualisées · brouillon à enregistrer"
        : "Modifications à enregistrer",
      nextStep: refreshed
        ? "L’actualisation est terminée. Enregistre ce brouillon, puis valide-le pour l’application."
        : "Enregistre les modifications avant la validation d’Anissa.",
      refreshLabel: refreshed ? "Actualisation terminée" : "Recettes à jour",
      refreshDisabled: true,
      tone: "ready",
    };
  }

  if (status === "validated") {
    return {
      label: "Validé par Anissa pour l’application",
      nextStep: "Cette version du Meal Prep est prête pour la publication.",
      refreshLabel: "Recettes à jour",
      refreshDisabled: true,
      tone: "validated",
    };
  }

  return {
    label: "Recettes à jour · validation Anissa requise",
    nextStep: "Le brouillon est enregistré. Anissa doit encore le valider pour l’application.",
    refreshLabel: "Recettes à jour",
    refreshDisabled: true,
    tone: "ready",
  };
}
